export default "__VITE_ASSET__CsLjfxcZ__"